<template>
  <div>
    <ErrorMessage v-if="errors.any" :error="errors.any" />

    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          {{ caption }}
        </h3>
        <div class="mt-2 max-w-xl text-sm text-gray-500">
          <p>Оцените главу и нажмите "Завершить".</p>
        </div>
        <div class="mt-5 flex">
          <label>
            <input v-model="mark" name="mark" type="radio" value="1" />
            <img src="/icons/star_gold.png" />
          </label>
          <label>
            <input v-model="mark" name="mark" type="radio" value="2" />
            <img v-if="mark > 1" src="/icons/star_gold.png" />
            <img v-else src="/icons/star_black.png" />
          </label>
          <label>
            <input v-model="mark" name="mark" type="radio" value="3" />
            <img v-if="mark > 2" src="/icons/star_gold.png" />
            <img v-else src="/icons/star_black.png" />
          </label>
          <label>
            <input v-model="mark" name="mark" type="radio" value="4" />
            <img v-if="mark > 3" src="/icons/star_gold.png" />
            <img v-else src="/icons/star_black.png" />
          </label>
          <label>
            <input v-model="mark" name="mark" type="radio" value="5" />
            <img v-if="mark > 4" src="/icons/star_gold.png" />
            <img v-else src="/icons/star_black.png" />
          </label>
        </div>
        <div class="mt-5">Ваша оценка - {{ mark }}</div>
        <div class="mt-5">
          <button
            type="button"
            class="inline-flex items-center justify-center px-4 py-2 border border-transparent font-medium rounded-md text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm"
            @click.prevent="finishChapter"
          >
            Завершить Главу
          </button>
        </div>
      </div>
    </div>

    <!-- <h3 class="text-lg leading-6 font-medium text-gray-900">{{ caption }}</h3>
    <div class="flex">
      <p class="your_mark">Ваша оценка - {{ mark }}</p>
    </div>

    <div class="alert alert-success shadow">
      <h3>{{ caption }}</h3>
      <p>Оцените главу и нажмите "Завершить".</p>
      <div class="p-0">
        <label>
          <input v-model="mark" name="mark" type="radio" value="1" />
          <img src="/icons/star_gold.png" />
        </label>
        <label>
          <input v-model="mark" name="mark" type="radio" value="2" />
          <img v-if="mark > 1" src="/icons/star_gold.png" />
          <img v-else src="/icons/star_black.png" />
        </label>
        <label>
          <input v-model="mark" name="mark" type="radio" value="3" />
          <img v-if="mark > 2" src="/icons/star_gold.png" />
          <img v-else src="/icons/star_black.png" />
        </label>
        <label>
          <input v-model="mark" name="mark" type="radio" value="4" />
          <img v-if="mark > 3" src="/icons/star_gold.png" />
          <img v-else src="/icons/star_black.png" />
        </label>
        <label>
          <input v-model="mark" name="mark" type="radio" value="5" />
          <img v-if="mark > 4" src="/icons/star_gold.png" />
          <img v-else src="/icons/star_black.png" />
        </label>
      </div>
      <p class="your_mark">Ваша оценка - {{ mark }}</p>
      <button
        type="button"
        class="btn btn-primary"
        @click.prevent="finishChapter"
      >
        Завершить Главу
      </button>
    </div> -->
  </div>
</template>
<script>
import axios from "axios";
import ErrorMessage from "@/components/ErrorMessage";

export default {
  props: {
    chapter: Object,
    caption: String,
  },
  components: {
    ErrorMessage,
  },
  data() {
    return {
      mark: 5,
      errors: { any: "" },
    };
  },
  mounted() {},
  methods: {
    async finishChapter() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "chapters/" + this.$route.params.id + "/finish",
          { mark: this.mark }
        );
        if (response.status == 200) {
          // Нельзя делать редирект на текущую страницу.
          // Поэтому если надо обновить текущую страницу, мы об этом передаём с помощью $emit:
          if (this.$route.name != "chapter_show") {
            this.$router.push({
              name: "chapter_show",
              params: { id: this.$route.params.id },
            });
          } else {
            this.$emit("need-to-reload");
          }
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при завершении Главы.";
        }
      }
    },
  },
};
</script>

<style scoped>
.your_mark {
  font-size: 80%;
  color: grey;
}
label {
  margin: 0;
}
label > input {
  /* HIDE RADIO */
  visibility: hidden; /* Makes input not-clickable */
  position: absolute; /* Remove input from document flow */
}
label > input + img {
  /* IMAGE STYLES */
  cursor: pointer;
  border: 2px solid transparent;
}
</style>